import React from 'react'
import { Link } from 'react-router-dom'
import { partnerBenefits } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const PartnerPreview = () => {
  return (
    <section className="csp-section csp-section--tint">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">For organizations</span>
            <h2 className="csp-title">
              Partner with Common Sense Politics. Use the platform. Keep your
              own Circle.
            </h2>
            <p className="csp-lead">
              We are looking for organizations whose goals already look like
              ours. The point is not to compete. It is to give the center a
              shared set of tools.
            </p>
          </div>
        </div>
        <div className="csp-grid csp-grid--2" style={{ marginTop: 40 }}>
          {partnerBenefits.slice(0, 4).map((benefit) => (
            <article className="csp-card csp-card--ruled" key={benefit.title}>
              <h3>{benefit.title}</h3>
              <p>{benefit.text}</p>
            </article>
          ))}
        </div>
        <div className="csp-more-row">
          <Link onClick={ClickHandler} className="csp-more" to="/partners">
            Partnership benefits
          </Link>
          <Link onClick={ClickHandler} className="csp-more" to="/how-it-works">
            How it would work for you
          </Link>
        </div>
      </div>
    </section>
  )
}

export default PartnerPreview
